// @ts-ignore
import Routing from "routing";

type PartialSuccessResponse = {
    code: number,
    message: string
};
type SuccessResponse = {
    code: number,
    message: string,
    targetUrl: string
};
type ErrorResponse = {
    code: number,
    message: string
};
export default class AuthorizationClient
{
    static async partialAuthorization(login: string, password: string)
    {
        return $.Deferred<PartialSuccessResponse, ErrorResponse>(function(def) {
            let url = Routing.generate('history_vision_user_auth');
            $.ajax({
                type: 'POST',
                url: url,
                data: {
                    username: login,
                    password: password
                }
            })
                .done(function(data) {
                    def.resolve(data);
                })
                .fail(function(xhr, message) {
                    def.reject(xhr.responseJSON || {
                        code: 500,
                        message: message
                    });
                });
        });
    }

    static async authorization(login: string, password: string, code: string, browserInfo:string)
    {
        return $.Deferred<SuccessResponse, ErrorResponse>(function(def) {
            let url = Routing.generate('history_vision_user_auth');
            $.ajax({
                type: 'POST',
                url: url,
                data: {
                    username: login,
                    password: password,
                    code: code,
                    browserInfo: browserInfo
                }
            })
                .done(function(data) {
                    def.resolve(data);
                })
                .fail(function(xhr, message) {
                    def.reject(xhr.responseJSON || {
                        code: 500,
                        message: message
                    });
                });
        });
    }
}
